module.exports = __webpack_public_path__ + "static/img/img.d39f6ed7.png";